import dayjs from 'dayjs'

import { useShopTime } from '../../../../Timezone/providers/ShopTimeProvider'
import type { AnalyticsCardProps } from '../analyticsModule/components/AnalyticsCard/AnalyticsCard.types'
import { useAnalyticsParams } from '../modules/AnalyticsParams/hooks/useAnalyticsParams'

export const useAnalyticsCardLegend = (): NonNullable<AnalyticsCardProps['legend']> => {
  const { toShopTime } = useShopTime()
  const { dateRange } = useAnalyticsParams()

  const [startDate, endDate] = dateRange.value.dates

  const shopStartDate = toShopTime(startDate)
  const shopEndDate = toShopTime(endDate)

  const isSameDay = shopStartDate.isSame(shopEndDate, 'day')
  if (isSameDay) {
    return dayjs(startDate).format('MMM D, YYYY')
  }

  const isSameYear = shopStartDate.isSame(shopEndDate, 'year')

  if (isSameYear) {
    const startFormatted = dayjs(startDate).format('MMM D')
    const endFormatted = dayjs(endDate).format('MMM D, YYYY')

    return `${startFormatted} - ${endFormatted}`
  }

  const startFormatted = dayjs(startDate).format('MMM D, YYYY')
  const endFormatted = dayjs(endDate).format('MMM D, YYYY')

  return `${startFormatted} - ${endFormatted}`
}
